module.exports = __webpack_public_path__ + "static/media/bullseye-thumb.4972bc1a.png";